<template>
    <v-menu
        :close-on-content-click="false"
        offset-y
        content-class="elevation-0"
        :nudge-top="0"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="value"
                :hide-details="hideDetails"
                readonly
                :rules="rules"
				:disabled="readonly"
                v-bind="attrs"
                v-on="on"
				:background-color="bgColor"
                prepend-inner-icon="mdi-clock-outline"
                outlined solo flat dense
            />
        </template>
        <v-row>
            <v-col class="py-0 pr-0">
                <v-list
                    class="overflow-y-auto"
                    :max-height="listMaxHeight"
                    outlined flat dense
                >
                    <v-list-item
                        v-for="hourItem in hourItems"
                        :key="hourItem"
                        @click="hour = hourItem"
                    >
                        <v-list-item-title v-text="hourItem" />
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col class="py-0 pl-0">
                <v-list
                    class="overflow-y-auto"
                    :max-height="listMaxHeight"
                    outlined flat dense
                >
                    <v-list-item
                        v-for="minItem in minItems"
                        :key="minItem"
                        @click="min = minItem"
                    >
                        <v-list-item-title v-text="minItem" />
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
    </v-menu>
</template>

<script>
export default {
    name: 'UiTimeSelector',
    model: {
        prop: 'value',
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        rules: {
            type: Array,
            default () {
                return [];
            }
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
        perMinute: {
            type: Number,
            default: 5
		},
		readonly: {
            type: Boolean,
            default: false
		},
    },
    data () {
        let hourItems = [];
        for (let h = 0; h < 24; h++) {
            hourItems.push(h.toString(10).padStart(2, '0'));
        }
        let minItems = [];
        for (let m = 0; m < 60; m += this.perMinute) {
            minItems.push(m.toString(10).padStart(2, '0'));
        }
        return {
            hourItems: hourItems,
            minItems: minItems,
            listMaxHeight: "250px",
        }
    },
    computed: {
        hour: {
            get () {
                return this.value.includes(':') ? this.value.split(':').shift().padStart(2, '0') : '';
            },
            set(val) {
                if (!this.readonly) this.$emit('input', val + ':' + this.min);
            }
        },
        min: {
            get () {
                return this.value.includes(':') ? this.value.split(':')[1].padStart(2, '0') : '';
            },
            set(val) {
                if (!this.readonly) this.$emit('input', this.hour + ':' + val);
            }
		},
		bgColor() {
			return this.readonly ? 'grey lighten-2' : undefined;
		},
    },
    created() {
        if (this.value.length == 0) {
            const now = new Date();
            const min5 = Math.floor(now.getMinutes() / 5) * 5;
            this.$emit('input', now.getHours().toString(10).padStart(2, '0') + ':' + min5.toString(10).padStart(2, '0'));
        }
    },
}
</script>